import * as ApplicationActions from "./application.actions";
import { createReducer, on } from "@ngrx/store";
import { recursive as mergeRecursive } from "merge";

const initialState = {
    searchTerm: "",
    toasts: [],
};

export const ApplicationReducer = createReducer(
    initialState,
    on(ApplicationActions.ExtendStateAction, (state, { newState }) => ({ ...state, ...newState })),
    on(ApplicationActions.MergeStateAction, (state, { newState }) => mergeRecursive(true, state, newState)),
    on(ApplicationActions.ShowToastAction, (state, { toast }) => ({
        ...state,
        toasts: [toast, ...state.toasts],
    })),
    on(ApplicationActions.HideToastAction, (state, { toast }) => ({
        ...state,
        toasts: state.toasts.filter(i => i !== toast),
    })),
);
